export default function select(array, selector) {
    return array.map(selector);
}
